import React from "react";
import { Check, X } from "lucide-react";

export default function Compare() {
  const formattedTopic = "Manual Email Discovery"; // Static comparison topic

  const data = [
    { feature: "Email Search Speed", exact: "Instant & Automated", topic: "Slow & Manual" },
    { feature: "CRM Integration", exact: true, topic: false },
    { feature: "Bulk Email Processing", exact: true, topic: false },
    { feature: "Verified Emails", exact: "97%+ Accuracy", topic: "Unverified Emails" },
    { feature: "Real-Time Updates", exact: true, topic: false },
    { feature: "Lead Generation", exact: true, topic: false },
    { feature: "Workflow Automation", exact: true, topic: false },
    { feature: "Productivity Boost", exact: "Saves Hours of Work", topic: "Repetitive & Time-Consuming" },
    { feature: "Zapier & Make Integrations", exact: true, topic: false },
    { feature: "Support", exact: "Priority Support", topic: "Limited or No Support" },
  ];

  return (
    <div className="flex justify-center items-center min-h-screen py-12">
      <div className="w-full mx-10 shadow-sm border-[1px] border-gray-200 rounded-xl overflow-hidden bg-white">
        <table className="w-full text-left border-collapse rounded-lg overflow-hidden">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-5 px-8 text-gray-800 font-bold text-base xl:text-xl border-b">
                Comparing ExactMails + Zapier vs. {formattedTopic}
              </th>
              <th className="py-5 px-8 text-center text-green-600 font-bold text-base xl:text-lg border-b">
                ExactMails + Zapier
              </th>
              <th className="py-5 px-8 text-center text-red-600 font-bold text-base xl:text-lg border-b">
                {formattedTopic}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.map(({ feature, exact, topic }, index) => (
              <tr
                className={`hover:bg-gray-100 ${index % 2 === 0 ? "bg-gray-50" : ""}`}
                key={index}
              >
                <td className="py-4 px-8 text-gray-800 border-b text-base">
                  {feature}
                </td>
                <td className="py-4 px-8 text-center border-b">
                  {typeof exact === "string" ? (
                    <span className="text-green-600 text-sm font-medium">{exact}</span>
                  ) : exact ? (
                    <div className="inline-flex items-center justify-center rounded-full bg-green-100 p-1">
                      <Check className="text-green-600" size={22} />
                    </div>
                  ) : (
                    <div className="inline-flex items-center justify-center rounded-full bg-red-100 p-1">
                      <X className="text-red-600" size={22} />
                    </div>
                  )}
                </td>
                <td className="py-4 px-8 text-center border-b">
                  {typeof topic === "string" ? (
                    <span className="text-red-600 text-sm font-medium">{topic}</span>
                  ) : topic ? (
                    <div className="inline-flex items-center justify-center rounded-full bg-green-100 p-1">
                      <Check className="text-green-600" size={22} />
                    </div>
                  ) : (
                    <div className="inline-flex items-center justify-center rounded-full bg-red-100 p-1">
                      <X className="text-red-600" size={22} />
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
